module.exports = __webpack_public_path__ + "img/p07.35069f46.jpg";